export const regex = "^[\\w\\d\\s'\\-\\.]{1,}$";
export default regex;
